<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="'Station Group'"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'listOrder'"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :moveActions="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      @click:move="move"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'Station Group'"
      :model="'stationgroups'"      
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import roleApi from "../api/role";
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../mixins/PermissionsHelper"
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";
import crudFuncsMixin from "../mixins/CRUDFuncs";

export default {
  name: "StationGroups",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin,PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "stationgroups",
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "List Order", value: "listOrder" },
      ],
      apiParams: {},
      formMeta: [
        {
          type: "text",
          label: "Name*",
          queryParam: "name",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "text",
          label: "Description",
          queryParam: "description",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        }
      ]
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>

